import { HandlerType } from './../models/HandlerType';
import { Contexto } from './../models/contexto';
import { ParamMap } from '@angular/router';
import { Injectable, EventEmitter } from '@angular/core';
import { FormElements } from '../models/FormElements';

@Injectable({
  providedIn: 'root'
})
export class AsistenteEnLineaUtils {
/*
public renderChat: boolean[] = [true, false, false];
  public renderEmail: boolean[] = [false, true, false];
  public renderMenu: boolean[] = [false, false, true]; */
  public renderChat: boolean[] =  [true, false, false, false,false];
  public renderEmail: boolean[] = [false, true, false, false,false];
  public renderMenu: boolean[] = [false, false, true, false,false];
  public renderMenuArbol: boolean[] = [false, false, false, true,false];
  public renderTramite: boolean[] = [false, false, false, false,true];

  public obtenerParametrosPortal(ctx: Contexto, params: ParamMap): Contexto {

    if (params.get('idServicio')) {
      ctx.idServicio = params.get('idServicio');
    }
    if (params.get('nroEmpresa')) {
      ctx.datosEmpresa.nroEmpresa = params.get('nroEmpresa');
    }
    if (params.get('nroContribuyente')) {
      ctx.datosEmpresa.nroContribuyente = params.get('nroContribuyente');
    }
    if (params.get('aportacion')) {
      // operador '+' convierte de string a number
      ctx.datosEmpresa.codigoAportacion = + params.get('aportacion');
    }
    if (params.get('nroObra')) {
      ctx.datosEmpresa.nroObra = params.get('nroObra');
    }
    if (params.get('codigoTema')) {
      ctx.codigoTema = params.get('codigoTema');
    }
    if (params.get('idNodo')) {
      ctx.idNodo = params.get('idNodo');
    }

    if (params.get('open')) {
      ctx.open = params.get('open') === 'true' ? true : false;
    }

    if (params.get('hideAfterClose')) {
      ctx.hideAfterClose = params.get('hideAfterClose') === 'true' ? true : false;
    }

    if (params.get('hideAllButtonsForm')) {
      ctx.hideAllButtonsForm = params.get('hideAllButtonsForm') === 'true' ? true : false;
    }
    if (params.get('goInside')) {
      ctx.goInside = params.get('goInside') === 'true' ? true : false;
    }
    if (params.get('refresh')) {
      ctx.refresh = params.get('refresh') === 'true' ? true : false;
    }
    if (params.get('fromAnonymous')) {
      ctx.fromAnonymous = params.get('fromAnonymous') === 'true' ? true : false;
    }
    
    if (params.get('contexto')) {
      ctx.contexto = params.get('contexto');
    }
    
    // Se agrega codAsistente para prueba de concepto de actualizar asistente desde el portal
    if (params.get('codAsistente')) {
      ctx.codAsistente = params.get('codAsistente');
    } else {
      ctx.codAsistente = ctx.idServicio;
    }
    ctx.codAsistenteOriginal = ctx.codAsistente;
    return ctx;
  }


  public evaluateConcergeResponse(handlerType: HandlerType, formElements: FormElements, response: any): void {
    if (response.handlerType === 'both') {
      handlerType.chat = true;
      handlerType.email = true;
      handlerType.menuArbol = true;
      formElements.datosEmpresa = response.formElements.datosEmpresa;
      formElements.datosObra = response.formElements.datosObra;
    } else {
      if (response.handlerType === 'chat') {
        handlerType.chat = true;
      }  else if (response.handlerType === 'email') {
        handlerType.email = true;
        formElements.datosEmpresa = response.formElements.datosEmpresa;
        formElements.datosObra = response.formElements.datosObra;
      }
      else if (response.handlerType === 'menuArbol'){
        handlerType.menuArbol = true;
      } else if (response.handlerType === 'tramite'){
        handlerType.tramite = true;
      }
    }

  }

  public getDescripcionAportacion(codigoAportacion: number): string {
    let resultado = "N/A";
    if (codigoAportacion) {
      switch (codigoAportacion) {
        case 1: {
          resultado = 'Industria y Comercio '
          break;
        }
        case 2: {
          resultado = 'Civil'
          break;
        }
        case 3: {
          resultado = 'Rural'
          break;
        }
        case 4: {
          resultado = 'Construcción'

          break;
        }
        case 5: {
          resultado = 'Caja Notarial'
          break;
        }
        case 6: {
          resultado = 'Caja Bancaria'
          break;
        }
        case 11: {
          resultado = 'Servicios Personales'
          break;
        } case 13: {
          resultado = 'Caja Policial'
          break;
        } case 48: {
          resultado = 'Servicio Doméstico'
          break;
        }
        default: {
          resultado = 'N/A'
          break;
        }
      }
      return resultado;
    }


  }

}
